<template>
	<div id="app">
		<p class="login" v-show="Islogin"><span @click="goLogin">登录</span><span class="register-span" @click="regist">注册</span></p>
		<p v-show="IsCenter" class="login"><span @click="goPerson">个人中心</span><span @click="logout"> | 退出</span></p>
		<p v-show="IsFirst" class="login"><span @click="goHome">首页 </span><span @click="logout"> | 退出</span></p>
		<el-menu v-if='IsPerson' :default-active="activeIndex" class="el-menu-nav" mode="horizontal" :router='true'>
			<el-menu-item index="/"><span class="dots">&deg;</span>平台简介</el-menu-item>
			<el-submenu index="entry">
				<template slot="title"><span class="dots">&deg;</span>投稿入口</template>
				<el-menu-item index="/commit">投递初稿</el-menu-item>
				<el-menu-item index="/review">提交复审材料</el-menu-item>
				<el-menu-item index="/progress">审核进度查询</el-menu-item>
			</el-submenu>
			<el-menu-item index="/reword"><span class="dots">&deg;</span>投稿回报</el-menu-item>
			<el-menu-item index="/show"><span class="dots">&deg;</span>案例展示</el-menu-item>
			<el-menu-item index="/aboutUs"><span class="dots">&deg;</span>关于我们</el-menu-item>
		</el-menu>
		<el-menu v-else :default-active="navselected" :active="navselected" class="el-menu-nav nav2 for-person" mode="horizontal" :router='true'>
			<el-menu-item index="/person/information" class='pageIndex'><span :class="{ isBlue: isBlueActive}">&deg;</span><span :class="{isBlue:isBlueActive}">个人中心</span></el-menu-item>
			<el-menu-item index="/message/privateLetter" style="border: none!important;">
				<el-badge :value="num" :max="99" :class="{ 'item': isA, 'fullNum': isB}"><span :class="{ isBlue: !isBlueActive}">&deg;</span><span :class="{ isBlue: !isBlueActive}">消息</span></el-badge>
			</el-menu-item>
		</el-menu>
		<router-view />
		<div class="foot">
			<div class="copyright">
				<div class="main">
					<div class="copyright-left">
						<a href="http://www.yokagames.com/" target="_blank"><img src="/static/img/n_logo.png" alt="" /></a>
						<span class="lines"></span>
						<a href="http://sq.ccm.gov.cn/ccnt/sczr/service/business/emark/toDetail/4028c08b5558c352015576c4a46a1eed" target="_blank"><img src="http://www.sanguosha.com/img/web/wen.png" alt="" /></a>
						<a href="http://www.cyberpolice.cn/wfjb/" target="_blank"><img src="http://www.sanguosha.com/img/web/jing.png" alt="" /></a>
						<span class="copy-gs">
						<img src="/static/img/icon_gs.jpg" alt="" />
						<!-- <script language="javaScript" src="http://zjnet.zjaic.gov.cn/bsjs/330108/33010800002238.js"></script> -->
					</span>
					</div>
					<div class="copyright-text">
						抵制不良游戏<span>|</span>拒绝盗版游戏<span>|</span>注意自我保护<span>|</span>谨防受骗上当<span>|</span>适度游戏益脑<span>|</span>沉迷游戏伤身<span>|</span>合理安排时间<span>|</span>享受健康生活<br> 网络文化经营许可证 浙网文[2016]0251-121号&nbsp;&nbsp;&nbsp;文网游备字[2010]C-CBG009号&nbsp;&nbsp;&nbsp;游戏批准文号 科技与数字【2010】284号<br> 增值电信业务经营许可证号码 [浙B2-20160108]&nbsp;&nbsp;&nbsp;浙公网安备 33010602006073号&nbsp;&nbsp;&nbsp;杭州游卡网络技术有限公司　版权所有<br> 杭州市西溪软件园金牛座A座7楼&nbsp;&nbsp;&nbsp;接待时间：周一至周五 9:00-17:00
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import { mapGetters } from 'vuex'
	export default {
		name: 'App',
		data() {
			return {
				activeIndex: '',
				navselected: '/person/information',
				num: 0,
				isA: true,
				isB: false,
				notBlueActive:true
			}
		},
		computed: {
			...mapGetters([
				'Islogin', 'IsPerson', 'IsFirst', 'IsCenter','isBlueActive','adminleftnavnum'
			]),
		},
		methods: {
			goPerson() {
				this.$router.push({
					path: '/person/information'
				})
				this.navselected = '/person/information'
				this.$store.commit('SET_ISPERSON', false)
				this.$store.commit('SET_ISLOGIN', false)
				this.$store.commit('SET_ISCENTER', false)
				this.$store.commit('SET_ISFIRST', true)
			},
			goLogin() {
				if(process.env.NODE_ENV == 'production') {
					var url = window.location.href
					var domain = url.match(/http[s]?:\/\/(.*?)([:\/]|$)/);
					var host = domain[0]
				} else if(process.env.NODE_ENV == 'development') {
					var host = process.env.BASE_URL
				}
				var thisUrl = (window.location.href).replace(new RegExp('/', 'g'), '$').replace(new RegExp('#', 'g'), '(')
				// var thisUrl = ''
				this.$alert('<iframe src="https://login.dobest.cn/sdo/Login/LoginFrameFC.php?target=top&appId=205&pm=2&unreport=1&areaId=1&loginifrmId=iframeLogin&proxyUrl=&returnURL=' + host + '/login/login/' + thisUrl + '&backUrl=' + host + '/login/login/"' + 'class="iframe"></iframe>', '', {
					dangerouslyUseHTMLString: true,
					showConfirmButton: false,
				});
			},
			goHome() {
				this.$router.push({
					path: '/'
				})
				this.activeIndex = '/'
				this.$store.commit('SET_ISPERSON', true)
				this.$store.commit('SET_ISLOGIN', false)
				this.$store.commit('SET_ISCENTER', true)
				this.$store.commit('SET_ISFIRST', false)
			},
			logout() {
				window.location.href = process.env.BASE_URL + '/login/logout'
			},
			ifReads() {
				axios({
						method: 'post',
						url: process.env.BASE_URL + '/notice/unread-count',
						withCredentials: true
					})
					.then(res => {
						this.num = res.data.data.count
						if(this.num == 0) {
							this.isB = true
						} else {
							this.isB = false
						}
					})
			},
			regist() {
        window.open('https://splus2.dobest.cn/register?appId=205')
			},
			getNavType(){
                this.navselected=this.$store.state.adminleftnavnum;
//              console.log(this.navselected)
                //store.state.adminleftnavnum里值变化的时候，设置navselected
            },
            selectItems(index){
                console.log(index)
                this.$store.state.adminleftnavnum=index;
               //按钮选中之后设置当前的index为store里的值。
            }
		},
		watch: {
            // 监测store.state
            '$store.state.adminleftnavnum': function(){
//          	this.navselected=this.$store.state.adminleftnavnum
//          	console.log('00',this.navselected)
            }
      	},
      	mounted(){
//          console.log(this.$store.state.adminleftnavnum,this.navselected)
        },
		created() {
			axios({
					method: 'get',
					url: process.env.BASE_URL + '/login/is-login',
					withCredentials: true
				})
				.then(res => {
					if(res.data.code == 10000) {
						//					//登录了
						// this.$store.commit('SET_ISPERSON', true)
						this.$store.commit('SET_ISPERSON', false)
						this.$store.commit('SET_ISLOGIN', false)
						this.$store.commit('SET_ISCENTER', true)
						this.$store.commit('SET_ISFIRST', false)
					} else {
						//未登录
						this.$store.commit('SET_ISPERSON', true)
						this.$store.commit('SET_ISLOGIN', true)
						this.$store.commit('SET_ISCENTER', false)
						this.$store.commit('SET_ISFIRST', false)
					}
				}),
				this.ifReads(),
				setInterval(() => {
					this.ifReads()
				}, 8000)

		},
	}
</script>

<style>
	#app {
		background: url(assets/img/bk.png) center top no-repeat;
		background-size: cover;
		height: 272px;
		width: 100%;
		min-width: 1000px;
	}

	.login {
		margin: 30px 100px 0 0;
		color: floralwhite;
		float: right;
		text-decoration: none;
		cursor: pointer;
	}

	.foot {
		width: 100%;
		height: 139px;
		background: #000;
		position: relative;
		/*bottom: 0;*/
	}

	.copyright {
		padding: 30px 0;
		/*overflow:hidden;*/
		color: #888;
	}

	.copyright .main {
		width: 1050px;
		margin: 0 auto;
		overflow: hidden;
		padding-top: 10px;
	}

	.copyright img {
		margin-right: 8px;
		vertical-align: middle;
	}

	.copyright .lines {
		width: 1px;
		height: 25px;
		border-left: 1px solid #4d4d4d;
		margin-right: 8px;
		vertical-align: middle;
		display: inline-block;
	}

	.copyright-left {
		width: 325px;
		padding-top: 10px;
		float: left;
	}

	.copyright-text {
		width: 666px;
		border-left: 1px solid #4d4d4d;
		font-size: 12px;
		padding-left: 16px;
		line-height: 18px;
		float: left;
		text-align: left;
	}

	.copyright-text span {
		color: #333;
		padding: 0 4px;
	}

	.copy-gs img {
		width: 40px;
	}

	.iframe {
		width: 435px;
		height: 405px;
		border: none;
	}

	.iframe-regist {
		width: 900px;
		height: 840px;
		border: none;
	}

	.nav2 {
		width: 1000px !important;
	}

	span.dots {
		padding: 5px 5px 0 0;
		display: inline-block;
		vertical-align: middle;
	}

	.register-span {
		margin-left: 40px;
	}

</style>



// WEBPACK FOOTER //
// src/App.vue